import { CartClient } from './cart-client';

export const metadata = {
  title: 'Shopping Cart | Alqove',
};

export default function CartPage() {
  return <CartClient />;
}
